// Схема приложения (Р-11). «System» — colorScheme Telegram (вне Telegram — системная схема браузера) → <html data-scheme>;
// токены цвета (src/ui/tokens.css) меняются по data-scheme. Шапка, фон и нижняя панель Telegram красятся фоном
// приложения (--ground), чтобы не было рамки чужого цвета. Telegram сменил тему (themeChanged) — пересчёт.
// Ручной выбор Light / Dark в меню (HQ-271) хранится в localStorage `football.theme` и главнее темы Telegram; «System» —
// схема Telegram и её смена на лету.
import { onThemeChanged, setChromeColor, telegramColorScheme } from '../telegram/webapp';

export type SchemeChoice = 'system' | 'light' | 'dark';
export type Scheme = 'light' | 'dark';

const THEME_KEY = 'football.theme';
const CHOICES: readonly SchemeChoice[] = ['system', 'light', 'dark'];

let choice: SchemeChoice = 'system';

/** Сохранённый выбор схемы; нет или испорчен — System. */
export function storedSchemeChoice(): SchemeChoice {
  let saved: string | null = null;
  try { saved = localStorage.getItem(THEME_KEY); } catch { /* нет хранилища — System */ }
  return CHOICES.includes(saved as SchemeChoice) ? (saved as SchemeChoice) : 'system';
}

/** Выбор человека в меню: применить и запомнить между открытиями (System — запись убирается). */
export function setSchemeChoice(next: SchemeChoice): Scheme {
  try {
    if (next === 'system') localStorage.removeItem(THEME_KEY); else localStorage.setItem(THEME_KEY, next);
  } catch { /* приватный режим — до перезапуска */ }
  return applyScheme(next);
}

export function resolveScheme(next: SchemeChoice, system: Scheme): Scheme {
  return next === 'system' ? system : next;
}

/** Применить схему: data-scheme на <html> и цвета Telegram = фон приложения. Возвращает итоговую схему. */
export function applyScheme(next: SchemeChoice = choice): Scheme {
  choice = next;
  const scheme = resolveScheme(next, telegramColorScheme());
  const root = document.documentElement;
  root.dataset.scheme = scheme;
  const ground = getComputedStyle(root).getPropertyValue('--ground').trim();
  setChromeColor(ground);
  return scheme;
}

/** Текущий выбор схемы (system / light / dark). */
export const schemeChoice = (): SchemeChoice => choice;

/** Старт: схема по сохранённому выбору (по умолчанию System) и подписка на смену темы Telegram. */
export function initTheme(initial: SchemeChoice = storedSchemeChoice()): () => void {
  applyScheme(initial);
  return onThemeChanged(() => applyScheme());
}
